import React, { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { messages } from "./messages";
import { Separator } from "../shared/styles";
import {
  Container,
  ToggleNameContainer,
  ToggleText,
  ToggleEnableEditionContainer,
  StyledFormCheck,
} from "./styles";
import { NAME_TYPE } from "../shared/constants";
import { calculateTableWidth } from "../shared/table";

interface Props {
  handleToggleName: (type: NAME_TYPE) => void;
  handleEnableEdition: () => void;
  nameType: NAME_TYPE;
  enableEdition: boolean;
  numberOfDays: number;
}

export const ActionsBar = ({
  handleToggleName,
  handleEnableEdition,
  nameType,
  enableEdition,
  numberOfDays,
}: Props): JSX.Element => {
  const intl = useIntl();
  const containerWidth = useMemo(() => calculateTableWidth(numberOfDays), [numberOfDays]);
  return (
    <Container width={containerWidth}>
      <ToggleNameContainer>
        <ToggleText
          onClick={() => handleToggleName(NAME_TYPE.SHORT)}
          selected={nameType === NAME_TYPE.SHORT}>
          <FormattedMessage {...messages.shortName} />
        </ToggleText>
        <Separator>|</Separator>
        <ToggleText
          onClick={() => handleToggleName(NAME_TYPE.FULL)}
          selected={nameType === NAME_TYPE.FULL}>
          <FormattedMessage {...messages.fullName} />
        </ToggleText>
      </ToggleNameContainer>

      <ToggleEnableEditionContainer>
        <StyledFormCheck
          aria-label="enable-edition"
          type="switch"
          id="custom-switch"
          checked={enableEdition}
          onChange={handleEnableEdition}
          label={intl.formatMessage(messages.enableEdition)}
        />
      </ToggleEnableEditionContainer>
    </Container>
  );
};
